<template>
  <div class="login-container">
    <div class="login-content clearfix">
      <div class="bg left">
        <img src="../assets/background_02.png" alt="">
      </div>
      <div class="login left" @keyup="clickEnter">
        <img src="../assets/logo.svg" alt="">
        <h2>电子文档加密系统</h2>
        <div class="user">
          <input type="text"  :placeholder="userPlaceholder" @focus="userActive(true)" @blur="userActive(false)" v-model="userName" >
        </div>
        <div class="password">
          <input :type="'password'" name="" id="" :placeholder="passwordPlaceholder" @focus="passwordPlaceholder = ''" @blur="passwordPlaceholder = '请输入密码'" v-model="password">
          <!-- <input :type="visible ? 'text' : 'password'" name="" id="" :placeholder="passwordPlaceholder" @focus="passwordPlaceholder = ''" @blur="passwordPlaceholder = '请输入密码'" v-model="password"> -->
          <!-- <div class="eye" @click="visible = !visible" :class="visible ? 'eye-02' : 'eye-01'"></div> -->
        </div>
        <el-checkbox v-model="isRemember" class="is-remember">记住密码</el-checkbox>
        <button  class="submit" @click="submit">登录</button>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { Checkbox, Message } from 'element-ui'
import { userLogin } from '@/common/http/server'
import {
  getStorage,
  setStorage
} from '@/common/utils/localStorage'

Vue.use(Checkbox)
//Vue.use(Message);
Vue.component(Message.name, Message)
export default {
  name: 'Login',
  components: {},
  data () {
    return {
      userName: '',
      userPlaceholder: '请输入账号',
      password: '',
      passwordPlaceholder: '请输入密码',
      userInputActive: false,
      isRemember: false,
      visible: false
    }
  },
  methods: {
    async submit () {
      setStorage("ticket", false);
      // this.$router.push('homepage')
      //this.$router.push({name:'Homepage'})
      let submitData = {
        user: this.userName,
        password: this.password
      }
      
      if (this.userName === '') {
        Message.error({
          message: '请输入账号'
        })
        return
      }
      if (this.password === '') {
        Message.error({
          message: '请输入密码'
        })
        return
      }
      //{data:{"staffId":submitData.userName}}
     
      // let restoken= await getToken({params:{staffId:this.userName}});
      // console.log(restoken)
      // if(restoken.StatusCode!=200){
      //   if(restoken.StatusCode==403){
      //     setStorage('token','')
      //   }
      //   Message.error({
      //     message: restoken.Info
      //   })
      //   return
      // }else{
      //   //setStorage('token',restoken)timestamp
      //   // setStorage('staffid',restoken.Data.StaffId)
      //   // setStorage('SignToken',restoken.Data.SignToken)
      //   // setStorage('ExpireTime',restoken.Data.ExpireTime)
      //   // setStorage('timestamp',timestamp)
      // }
      let response = await userLogin({data:submitData})
      
      if (response.error === undefined) {        
        setStorage('user', response)
        setStorage('ticket', response.ticket)
        if(this.isRemember==true){
          let pwdStroage=response.cn+"pwd";
          setStorage(pwdStroage, submitData.password)
        }
        //console.log(getStorage('ticket'));
        if(getStorage('ticket')){
          this.$router.push({name:'Homepage'})
        }else{
          this.$router.push({name:'Login'})
        }
        //this.$router.push({name:'Homepage'})
      } else {
        Message.error({
          message: response.error
        })
      }
    },

    clickEnter(e){
      if (e.code === 'Enter' || e.key === "Enter" || e.keyCode === 13) {
        this.submit()
      }
    },
    toDownload () {
      let routeData = this.$router.resolve({path: '/download_app'})
      window.open(routeData.href, '_black')
    },
    userActive(status) {
      let pwdStroage=this.userName+"pwd";
      
      if(getStorage(pwdStroage)!=null){
          this.password=getStorage(pwdStroage)
      }
      if (status) {
        this.userPlaceholder = ''
        this.userInputActive = true
      } else {
        this.userPlaceholder = '请输入账号'
        this.userInputActive = false
      }
      return status;
    }
    ,
    canSelectAccount() {
      return (this.userInputActive === true) && (this.userPlaceholder === '')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style lang="scss" >
  @import "@/common/theme/myTheme.scss";

  .left {
    float: left;
  }
  .clearfix {
    &::after {
      display: block;
      content: "";
      clear: both;
    }
  }
  ul {
    margin: 0;
    padding: 0;
    list-style: none;
  }
  .login-container {
    background-image: url(../assets/background_01.png);
    background-repeat: no-repeat;
    background-size: cover;
    min-width: 960px;
    min-height: 800px;
    height: 100vh;
    .login-content {
      margin: 0 auto 0 auto;
      padding-top: 10%;
      width: 800px;
      height: 520px;
      .login {
        width: 320px;
        height: 520px;
        text-align: center;
        background: #fff;
        border-radius: 0 5px 5px 0;
        img {
          margin-top: 60px;
        }
        h2 {
          margin-top: 25px;
          font-weight: normal;
        }
        .user {
          width: 240px;
          border: none;
          outline: none;
          padding: 10px 0;
          margin: 50px auto 0 auto;
          border-bottom: 1px solid $lightGray;
          position: relative;
          input {
            width: 100%;
            border: none;
            outline: none;
          }
          .account {
            position: absolute;
            top: 38px;
            z-index: 99;
            background-color: #F6F8FB;
            li {
              width: 100%;
              padding: 10px 0;
              border-bottom: 1px solid #E4E6EB;
            }
            .account-name {
              width: 215px;
              text-align: left;
              &:hover {
                cursor: pointer;
              }
            }
            .delete {
              width: 25px;
              &:hover {
                cursor: pointer;
              }
              img {
                margin: 0;
              }
            }
          }
        }
        .password {
          width: 240px;
          border: none;
          outline: none;
          padding: 10px 0;
          margin: 10px auto 0 auto;
          text-align: left;
          border-bottom: 1px solid $lightGray;
          position: relative;
          input {
            width: 210px;
            border: none;
            outline: none;
          }
          // .eye {
          //   width: 16px;
          //   height: 16px;
          //   position: absolute;
          //   right: 5px;
          //   top: 10px;
          //   &:hover {
          //     cursor: pointer;
          //   }
          // }
          // .eye-01 {
          //   background: url(../assets/eye_01.svg)
          // }
          // .eye-02 {
          //   background: url(../assets/eye_02.svg)
          // }
        }
        .is-remember {
          display: block;
          margin-left: -168px;
          margin-top: 10px;
          font-size: 14px;
          color: rgb(117, 117, 117);
        }
        .submit {
          width: 240px;
          padding: 10px 0;
          color: #fff;
          background: $lightBlue;
          border: none;
          outline: none;
          border-radius: 20px;
          margin-top: 40px;
          &:hover {
            cursor: pointer;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/login.vue